var init;

init = function() {
  return mermaid.initialize({
    startOnLoad: true
  });
};

$(init);
